// lessons/les1-motiverende-gespreksvoering/modules/Module6.js
export const MODULE6_CONFIG = {
    id: 'module6',
    title: 'Eindopdracht: Integratie van Alle Vaardigheden',
    type: 'conversation',
    duration: 65,
    
    theory: {
      title: 'Eindopdracht',
      sections: [
        {
          id: 'spirit',
          title: 'Gesprekstechnieken binnen de spirit van motiverende gespreksvoering',
          content: `Je hebt in de vorige modules kunnen oefenen met twee basisvaardigheden van motiverende gespreksvoering: open vragen stellen en reflecteren. Wanneer je deze technieken correct toepast kan je samen met je cliënt ambivalentie verkennen en verandertaal ontlokken. Bedenk dat dit maar een fractie is van wat motiverende gespreksvoering te bieden heeft. Andere belangrijke vaardigheden, zoals bevestigen, samenvatten en informatie geven, zijn niet behandeld in deze scholing. Daarnaast zit er ook een logische opbouw in een goed gesprek over motivatie, en heb je naast deze praktische kanten ook een basishouding, die ook wel spirit van motiverende gespeksvoering genoemd wordt. In volgende online trainigen komen deze aspecten verder aan bod. We willen nu wel kort de aandacht richten op de spirit van motiverende gespreksvoering, zodat je de vaardigheden die je hebt geleerd kan plaatsen in een groter geheel. 
          

         Deze spirit bestaat uit vier kernwaarden: 

- **Partnerschap:** je werkt samen met de cliënt als gelijkwaardige gesprekspartner.
- **Acceptatie:** je respecteert de autonomie en keuzes van de cliënt.
- **Compassie:** je toont oprechte betrokkenheid bij het welzijn van de cliënt.
- **Ontlokken:** je vertrouwt erop dat motivatie en oplossingen bij de cliënt zelf vandaan komen.

In de volgende simulatiegesprekken staat deze houding centraal. Je krijgt ruimte om je vaardigheden op jouw manier in te zetten en te ervaren hoe jouw gesprekshouding en interventies bijdragen aan het ontstaan van verandertaal.`
        },
                {
          id: 'introductie opdracht',
          title: 'Introductie Opdracht',
          content: `**Uitleg**
          
      In de volgende simulatiegesprekken richt je je niet meer op een specifieke techniek. Het doel is nu om je cliënt zes keer verandertaal uit te laten spreken. Hoe je dat doet, met vragen, reflecties of andere technieken, mag je zelf bepalen.

Je spreekt eerst met Peter en vervolgens met Bram.

**Tips**

Het helpt als je in je achterhoofd houdt dat er vier soorten verandertaal zijn: wensen, vermogen, redenen en noodzaak. Je kan deze categorieën gebruiken als inspiratie voor open vragen, en om snel te herkennen wanneer jouw cliënt verandertaal uitspreekt.

Wees tijdens het gesprek niet te veel bezig met het tellen van uitingen van verandertaal. Ga het gesprek aan en check na een tijdje hoeveel verandertaal de cliënt heeft uitgesproken. Je kunt ook tussentijds op ‘evalueer gesprek’ klikken voor tips en feedback, ook als je de opdracht nog niet hebt behaald.

          `
        }
      ]
    },
  
    conversations: {
      total: 2,
      passingCriteria:  'In elk van de twee simulatiegesprekken lok je minimaal 6 uitingen van verandertaal uit bij de cliënt (chatbot). Hoe je dit doet (open vragen, reflecties, samenvatten, etc.) is vrij; de beoordeling gaat over de mate waarin verandertaal ontstaat en hoe passend je daarop reageert.',
      
      instruction: `Nu pas je alle technieken uit de training toe om je cliënten richting gedragsverandering te gidsen. Je lokt verandertaal uit, je herkent verandertaal en reageert daarop met reflecties en open vragen.

Je behaalt de opdracht wanneer jouw cliënt zes keer verandertaal uitspreekt.`,

      afterConversation1: `Goed gedaan! Jouw cliënt heeft zes keer verandertaal uitgesproken. Lees nu onderstaande feedback op jouw gesprekstechnieken, en pas deze toe in het volgende gesprek!

Tip: schrijf op welke feedback jij nuttig vindt om mee te nemen in het volgende simulatiegesprek!`,

      afterConversation2: `Goed gedaan! Jouw cliënt heeft zes keer verandertaal uitgesproken. Je hebt de training voltooid!

Tip: schrijf op welke feedback jij nuttig vindt om toe te passen in jouw praktijk als behandelaar!`
    },
  
    completionCriteria: {
  type: 'conversation_evaluation',
  
  requiredConversations: 2,
  requiredChangeTalkUtterancesPerConversation: 6,

  description:
    'Beide gesprekken succesvol afgerond; per gesprek minimaal 6 uitingen van verandertaal uitgelokt bij de cliënt'
    }
  };
  
  export default MODULE6_CONFIG;